import React from 'react'
import { CalculatorForm } from '../components/calculator-form'

export function App() {
  return (
    <div className="min-h-screen">
      <main className="py-12">
        <CalculatorForm />
      </main>
    </div>
  )
} 